// @ts-ignore
import { Component, ContentChild, OnInit, ViewChild } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UnidadeFormComponent } from '../unidade-form/unidade-form.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { StepsComponent } from 'src/app/shared/components/steps/steps.component';
import { Store } from '@ngrx/store';
import { IUnidadeState } from 'src/app/store/unidade/unidade.reducer';

import { deleteUnidade, editUnidade, loadUnidade } from 'src/app/store/unidade/unidade.actions';
import { selectUnidadeLista, selectUnitState } from 'src/app/store/unidade/unidade.selectors';
import { IUnidade } from 'src/app/shared/interfaces/unidade/iunidade';
import { IUnitTaxInfo } from 'src/app/shared/interfaces/unidade/iunittaxinfo';
import { UnidadeFilter, UnidadeService } from 'src/app/shared/services/unidade.service';
import { PostalCodeService } from 'src/app/shared/services/postal-code.service';
import { FilterModel } from 'src/app/shared/components/split-button-filter/split-button-filter.component';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NotifyService } from 'src/app/shared/services/notify.service';
// import { CadastroUnidades } from '../cadastro-unidades';

@Component({
  selector: 'app-unidade-lista',
  templateUrl: './unidade-lista.component.html',
  styleUrls: ['./unidade-lista.component.scss'],
})
export class UnidadeListaComponent implements OnInit {

  readonly ID_CITY_FILTER = "city";
  readonly ID_TIPO_FILTER = "tipo";
  filter = new UnidadeFilter();
  protected copyButtonIcon: string = 'pi pi-copy'
  mostrarModalDeletar: boolean = false;
  mostrarModalInativar: boolean = false;
  mostrarModalAtivar: boolean = false

  selectedItemId: number = 9999999999
  selectedItem: any

  ref: DynamicDialogRef | undefined;

  listaUnidades$ = this.store.select(selectUnidadeLista);

  filters: Array<any> = [
    {
      id: "tipo",
      type: "DROPDOWN",
      name: "Tipo",
      data: [
        {
          value: "Matriz",
          code: true
        },
        {
          value: "Filial",
          code: false
        }
      ]
    }
  ]

  @ContentChild('steps') steps!: StepsComponent
  unitState$ = this.store.select(selectUnitState)
  completeUnitList: any
  filteredUnitList: any

  constructor(
    public dialogService: DialogService,
    public modalService: ModalService,
    public unidadeService: UnidadeService,
    private store: Store<IUnidadeState>,
    public postalCodeService: PostalCodeService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public notify: NotifyService
  ) { }


  ngOnInit(): void {
    this.store.dispatch(loadUnidade());

    this.store.select(selectUnidadeLista).subscribe(res => {
      this.completeUnitList = res
      this.filteredUnitList = res.filter((u: any) => u.isActive == true)
    })

    this.unitState$.subscribe(res => {
      //console.log('unit state: ', res)
      if (res.action != 'get' && res.type == 'success') {
        this.store.dispatch(loadUnidade());
      }
    })

    let unit = this.activatedRoute.snapshot.queryParams["unit"];

    if (unit) {
      this.unidadeService.getById(unit).subscribe(data => {
        this.editarUnidade(data);
        this.router.navigate([], { relativeTo: this.activatedRoute, queryParams: {} });
      })
    }
  }
  /*
  loadFilterCity(cities : any[]) {
    let data = cities.map(city => {
      return {value : city.nome , code : city.id }
    })
    this.filters.push({
      id: "city",
      type: "DROPDOWN",
      name: "Cidade",
      data: data
    })
  }*/
  search(value: string) {
    //this.filter.unitName = name;
    this.unidadeService.setSearch(["unitName", "address.city"], value);
    this.store.dispatch(loadUnidade());
  }
  filterCity(city: string) {
    this.filter.city = city;
    this.unidadeService.setFilter(this.filter);
    this.store.dispatch(loadUnidade());
  }
  setFilterActive() {
    //this.unidadeService.setFilter(this.filter);
    //this.store.dispatch(loadUnidade());

    this.filterLocalList()
  }
  setFilter(filter: FilterModel[]) {

    let tipoFilter = this.listCheckedTrue(<FilterModel>filter.find(item => item.id == this.ID_TIPO_FILTER));
    //console.log(tipoFilter);
    this.filter.main = null;
    if (tipoFilter.data.length == 1) {
      this.filter.main = tipoFilter.data[0].code;
    }

    //this.unidadeService.setFilter(this.filter);

    //console.log('filter: ', this.filter)
    //this.store.dispatch(loadUnidade())
    this.filterLocalList()
  }

  filterLocalList() {
    //console.log('local filter: ', this.filter)
    this.filteredUnitList = this.completeUnitList.filter((u: any) => u.isActive == this.filter.isActive)

    if (this.filter.main != null) {
      //console.log('filter by main')
      this.filteredUnitList = this.filteredUnitList.filter((u: any) => u.main == this.filter.main)
    }
  }

  listCheckedTrue(filter: FilterModel): FilterModel {
    let newFilterModel = new FilterModel(filter);
    newFilterModel.data = newFilterModel.data.filter(item => item.checklist == true);
    return newFilterModel;
  }

  public deletarUnidade(index: number) {

    this.mostrarModalDeletar = !this.mostrarModalDeletar;
    this.selectedItemId = index

  }

  public inativarUnidade(item: any) {
    this.mostrarModalInativar = !this.mostrarModalInativar;

    this.selectedItem = item
  }

  public inativarUnidadePatch() {
    let req = { ...this.selectedItem }
    req.isActive = false
    req.mainUnit ? req.mainUnit = req.mainUnit['@id'] : null
    req.occupationArea ? req.occupationArea = req.occupationArea!['@id'] : null
    //eq)

    this.store.dispatch(editUnidade({ unidade: req, id: req.id }))
    this.fecharDialog()
  }

  public ativarUnidade(item: any) {
    this.mostrarModalAtivar = !this.mostrarModalAtivar;

    this.selectedItem = item
  }

  public ativarUnidadePatch() {
    let req = { ...this.selectedItem }
    req.isActive = true
    req.mainUnit ? req.mainUnit = req.mainUnit['@id'] : null
    req.occupationArea ? req.occupationArea = req.occupationArea!['@id'] : null
    //eq)

    this.filter.isActive = true;

    this.store.dispatch(editUnidade({ unidade: req, id: req.id }))
    this.fecharDialog()

  }

  public editarUnidade(unidade: IUnidade | IUnitTaxInfo) {

    this.modalService.calledfor('editar')
    //this.modalService.show(UnidadeFormComponent, 'Editar Unidade', { id: index });
    //this.modalService.show(UnidadeEditarComponent, 'Editar Unidade');

    this.modalService.show(UnidadeFormComponent, 'Editar Unidade', unidade);

  }

  public cadastrarUnidade() {
    this.modalService.calledfor('cadastrar')
    this.modalService.show(UnidadeFormComponent, 'Cadastro de Unidade');

  }

  public delete() {

    this.store.dispatch(deleteUnidade({ id: this.selectedItemId }));
    this.fecharDialog()

  }

  public fecharDialog() {
    this.ref?.destroy()

    this.mostrarModalDeletar = false
    this.mostrarModalInativar = false
    this.mostrarModalAtivar = false
  }

  onCopyText(text: string) {
    navigator.clipboard.writeText(text)

    this.copyButtonIcon = 'pi pi-check'
  }

  onSubmitLinkByEmail(id: number) {
    this.unidadeService.sendEmail(id, 'unit').subscribe({
      next: () => { this.notify.emitSuccess('Um email com o link foi enviado') },
      error: () => { this.notify.emitWarn('Não foi possivel enviar o email, tente novamente.') }
    })
  }

  onHideOverlayPanel() {
    this.copyButtonIcon = 'pi pi-copy'
  }

}
